import { Component, ElementRef, viewChild } from '@angular/core';

@Component({
  selector: 'lepi-modal-container',
  template: `
    <section
      #modal
      class="box-border flex h-[100dvh] w-full max-h-[100dvh] max-w-full flex-col overflow-x-hidden overflow-y-hidden border-x-0 border-y border-base-200 bg-base-100 shadow-2xl md:h-auto md:max-h-[calc(100dvh-2rem)] md:w-auto md:max-w-[calc(100vw-2rem)] md:rounded-2xl md:border-x">
      <section class="shrink-0">
        <ng-content select="[header]" />
      </section>
      <section
        class="min-h-0 flex-1 overflow-x-hidden overflow-y-auto md:min-w-120 md:max-h-240 md:h-auto">
        <ng-content />
      </section>
      <section class="sticky bottom-0 shrink-0 w-full bg-base-100 md:static">
        <ng-content select="[footer]" />
      </section>
    </section>
  `,
  imports: [],
})
export class ModalContainer {
  modalRef = viewChild<ElementRef<HTMLElement>>('modal');

  ngAfterViewInit() {
    this.modalRef()?.nativeElement.animate(
      [
        { opacity: 0, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      {
        duration: 200,
        easing: 'ease-in-out',
      }
    );
  }
}
